import { makeStyles } from '@material-ui/core'

import { lang } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  paperWeekly: {
    zIndex: 10,
    position: 'sticky',
    top: 65,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    display: 'grid',
    gridTemplateColumns: '5.42fr repeat(14,1fr)',
    height: 60,
    marginBottom: 20,
    backgroundColor: theme.palette.background.default,
    border: `2px solid ${theme.palette.grey[200]}`
  },

  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 14,
    color: 'gray',
    borderLeft: `1px solid ${
      theme.palette.type === 'dark' ? '#555' : '#e7e7e7'
    }`
  },
  dayContainerSmall: {
    fontSize: 12
  },
  arrowIcon: {
    transform: `rotate(${lang === 'fa' ? '180deg' : '0deg'})`
  },
  prevPageIcon: {
    transform: `rotate(${lang === 'fa' ? '0deg' : '180deg'})`
  },
  bigDateContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '10%'
  },
  bigDate: {
    width: 170,
    textAlign: 'center'
  },
  bidDateContainer: {
    position: 'relative'
  },
  datePickerContainer: {
    position: 'absolute',
    top: 32,
    zIndex: 1
  },
  weekendDayContainer: {
    backgroundColor:
      theme.palette.type === 'dark' ? `rgba(120, 132, 255,0.25)` : '#fff2f2'
  }
}))

export default useStyles
